import { Box, Grid, Typography } from "@mui/material";
import type { LLMConfigFormData, ModelTypeConfig } from "../types";

type ModelCapabilitySelectorProps = {
  formData: LLMConfigFormData;
  modelTypes: ModelTypeConfig[];
  activeDescription?: string;
  disabled?: boolean;
  onSelect: (key: ModelTypeConfig["key"]) => void;
};

const ModelCapabilitySelector = ({
  formData,
  modelTypes,
  activeDescription,
  disabled,
  onSelect,
}: ModelCapabilitySelectorProps) => (
  <Grid item xs={12} md={12} className="mb-1">
    <Box className="flex items-center gap-2 mb-2 flex-wrap">
      {modelTypes.map(({ key, label, icon: Icon }) => {
        const isActive = formData[key];

        return (
          <Box
            key={key}
            data-testid={`ai-catalog-form-model-type-${key}`}
            className={`cursor-pointer flex min-h-6 px-2 py-[3px] justify-center items-center gap-1 rounded border bg-[var(--border)] ${
              isActive ? "border-[var(--primary)]" : "border-[var(--border)]"
            }`}
            onClick={() => {
              if (!disabled) onSelect(key);
            }}
          >
            <Icon
              className={
                isActive
                  ? "text-[var(--primary)]"
                  : "text-[var(--secondary-foreground)]"
              }
            />
            <Typography className="text-xs font-medium text-[var(--foreground)]">
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
    {activeDescription ? (
      <Typography className="text-xs font-normal text-[var(--muted-foreground)]">
        {activeDescription}
      </Typography>
    ) : null}
  </Grid>
);

export default ModelCapabilitySelector;
